import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { FiEdit } from "react-icons/fi";
import Footer1 from "../../components/Footers/Footer1.component";
import AuthHeader from "../../components/Headers/AuthHeader.component";
import UserReviews from '../../components/UserReviews.component';
import ReactImageFallback from "react-image-fallback";


// images
import defaultUser from "../../assets/images/default_profile_pic.jpg";


export default function UserProfile() {
  let userData = useSelector(state => state.auth.data);
  const islogin = useSelector((state) => state.auth.isLogin);

  return (
    <>
      <AuthHeader />

      {userData ? (
        <section className="bds-main-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-8">
                <div className="bds-sectiontitle user-profile">
                  <div className="bds-featureRating">
                    <div className="d-flex align-items-start mb-5 flex-wrap">
                      <p className="edit_profile_photo">
                        <ReactImageFallback
                          src={`https://3bidsapp.com/dev/public/storage/${userData?.profile_image}`}
                          fallbackImage={defaultUser}
                          initialImage={defaultUser}
                          alt="user image"
                          width={"180px"}
                          height={"180px"}

                          className="rounded-circle d-block bg-secondary"
                        />
                      </p>
                      <div className="ms-4 mt-4">
                        <h3 className="mb-2">{userData?.first_name != null || userData?.last_name != null ?
                          userData?.first_name + " " + userData?.last_name : userData?.name}</h3>
                        <p className="mb-2">
                          {userData?.role?.id == 3 && "Customer"}
                          {userData?.role?.id == 2 && "Service Provider"}
                        </p>
                        {islogin ? (
                          <Link to={`/profile/${userData?.id}`} className="d-flex align-items-center">
                            <span className="me-2">Edit Profile</span>
                            <FiEdit />
                          </Link>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>

                  <ul
                    className="nav nav-pills mt-5 mb-3 bds-tabs-container"
                    id="pills-tab"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link text-dark px-0 me-4 rounded-0 fw-bold active"
                        id="pills-profile-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-profile"
                        type="button"
                        role="tab"
                        aria-controls="pills-profile"
                        aria-selected="true"
                      >
                        Profile
                      </button>
                    </li>
                    {
                      userData?.role == 2 &&
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link text-dark px-0 me-4 rounded-0 fw-bold"
                          id="pills-reviews-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-reviews"
                          type="button"
                          role="tab"
                          aria-controls="pills-reviews"
                          aria-selected="false"
                        >
                          Reviews
                        </button>
                      </li>
                    }
                  </ul>

                  <div className="tab-content" id="pills-tabContent">
                    <div
                      className="tab-pane fade show active"
                      id="pills-profile"
                      role="tabpanel"
                      aria-labelledby="pills-profile-tab"
                    >
                      <div className="bds-box">
                        <h4>Information</h4>
                        <div className="table-responsive">
                          <table className="table user-info-table">
                            <tbody>
                              {
                                userData?.first_name && userData?.last_name ?
                                  (
                                    <tr>
                                      <th>Full Name</th>
                                      <td>{userData?.first_name + " " + userData?.last_name}</td>
                                    </tr>
                                  ) : ""


                              }
                              <tr>
                                <th>Username</th>
                                <td>{userData?.name}</td>
                              </tr>
                              <tr>
                                <th>Mobile Number</th>
                                <td>{userData?.phone_number}</td>
                              </tr>
                              <tr>
                                <th>Email Address</th>
                                <td>{userData?.email}</td>
                              </tr>
                              <tr>
                                <th>Address</th>
                                <td>{userData?.address}</td>
                              </tr>
                              {userData?.experience ? (
                                <tr>
                                  <th>Experience</th>
                                  <td>{userData?.experience}</td>
                                </tr>
                              ) : (
                                ""
                              )}
                              <tr>
                                <th>No. Of Jobs Completed</th>
                                <td>{userData?.no_of_jobs_completed}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    {
                      userData?.role == 2 &&
                      <div
                        className="tab-pane fade"
                        id="pills-reviews"
                        role="tabpanel"
                        aria-labelledby="pills-reviews-tab"
                      >
                        <UserReviews 
                          userID={userData?.id}
                          role={userData?.role}
                        />
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        ""
      )}

      <Footer1 />
    </>
  );
}
